import { EventCallback, IPlayer } from './index';

export class Observer {
  public static initialize(emitter: IPlayer) {
    Observer._emitter = emitter;
  }

  public static on(eventType: string, listener: EventCallback): void {
    Observer._emitter.on(eventType, listener);
  }

  public static off(eventType: string, listener: EventCallback): void {
    Observer._emitter.off(eventType, listener);
  }

  public static emit(eventType: string, data?: any) {
    Observer._emitter.emit(eventType, data);
  }
  public static getInstance() {
    return Observer._emitter;
  }
  private static _emitter: IPlayer;
}
